import * as React from 'react';
import {
  DashboardOutlined,
  CalendarOutlined,
  ScanOutlined,
  ExceptionOutlined,
  WalletOutlined,
  EuroOutlined,
  SwapOutlined,
  UserOutlined,
  FundProjectionScreenOutlined,
  ApartmentOutlined,
  DotChartOutlined,
  ClusterOutlined,
} from '@ant-design/icons';
import { userClaims } from './claims-prefix';

export interface MenuItem {
  path?: string;
  claim?: string;
  title: string;
  icon?: React.JSX.Element;
  onClick?: any;
  key?: string;
  children?: this[]; // TODO: Is this good? :)
}

export const menu: MenuItem[] = [
  {
    path: '/dashboard',
    title: 'Dashboard',
    claim: userClaims.dashBoardPrefix,
    icon: <DashboardOutlined />,
  },
  {
    path: '/sport-betting',
    title: 'Betting',
    claim: userClaims.sportBettingPrefix,
    icon: <CalendarOutlined />,
    children: [
      {
        path: '/sport-betting/events',
        title: 'EVENT_PREMATCH',
        claim: userClaims.sbPrematch,
      },
      {
        path: '/sport-betting/live-events',
        title: 'EVENT_LIVE_EVENTS',
        claim: userClaims.sbLive,
      },
      {
        path: '/sport-betting/import',
        title: 'Import',
        claim: userClaims.sbImport,
      },
      {
        path: '/sport-betting/bet-restrictions',
        title: 'Limits',
        claim: userClaims.sbBetRestrictions,
      },
      {
        path: '/sport-betting/betting-statistics',
        title: 'GENERAL_STATISTICS',
        claim: userClaims.sbEventsStatistics,
      },
      {
        path: '/sport-betting/competitions-data',
        title: 'EVENT_COMPETITIONS',
        claim: userClaims.sbCompetitionData,
      },
      {
        path: '/sport-betting/games',
        title: 'GAMES_SETTINGS',
        claim: userClaims.sbBetsRead,
      },
    ],
  },
  {
    path: '/risk',
    title: 'Risk',
    icon: <ScanOutlined />,
    claim: userClaims.riskPrefix,
    children: [
      {
        path: '/risk/verification',
        title: 'RISK_TICKET_VERIFICATION',
        claim: userClaims.riskVerification,
      },
      {
        path: '/risk/settings',
        title: 'RISK_MANAGEMENT',
        claim: userClaims.riskSettings,
      },
    ],
  },
  {
    path: '/tickets',
    title: 'Tickets',
    icon: <ExceptionOutlined />,
    claim: userClaims.ticketsSportBetting,
    children: [
      {
        path: '/tickets/list',
        title: 'TICKETS_LIST',
        claim: userClaims.ticketsSportBetting,
      },
      // {
      //   path: '/tickets/summary',
      //   title: 'TICKETS_SUM',
      //   claim: userClaims.businessPrefix
      // }
    ],
  },
  {
    path: 'transactions-info',
    title: 'TRANSACTIONS/BALANCE',
    icon: <FundProjectionScreenOutlined />,
    children: [
      {
        path: '/transactions-info/transactions',
        title: 'Transactions',
        claim: userClaims.businessPrefix,
      },
      {
        path: '/transactions-info/balance',
        title: 'Balance',
        claim: userClaims.businessPrefix,
      },
    ],
  },
  {
    path: '/lucky-six',
    title: 'Lucky Six',
    icon: <DotChartOutlined />,
    claim: userClaims.devToolsNodes,
    children: [
      {
        path: '/lucky-six/tickets',
        title: 'TICKETS_LIST',
        claim: userClaims.devToolsNodes,
      },
      {
        path: '/lucky-six/balance',
        title: 'Balance',
        claim: userClaims.devToolsNodes,
      },
    ],
  },
  {
    path: '/e-commerce',
    title: 'E-commerce',
    icon: <EuroOutlined />,
    claim: userClaims.ecommercePrefix,
    children: [
      {
        path: '/e-commerce/bank',
        title: 'Bank',
        claim: userClaims.ecommerceBank,
      },
      {
        path: '/e-commerce/tobacco-shop',
        title: 'TOBACCO_SHOP',
        claim: userClaims.ecommerceTobacco,
      },
      {
        path: '/e-commerce/skrill',
        title: 'Skrill',
        claim: userClaims.ecommerceSkrill,
      },
    ],
  },
  {
    path: '/quota-changes',
    title: 'Promena kvota',
    icon: <SwapOutlined />,
    claim: userClaims.quotaMgtPrefix,
    children: [
      {
        path: '/quota-changes/quotas',
        title: 'Kvote',
        claim: userClaims.quotaMgtQuotas,
      },
      // {
      //   path: '/quota-changes/sessions',
      //   title: 'HISTORY_OF_CHANGES',
      //   claim: userClaims.quotaMgtQuotas,
      // },
      {
        path: '/sport-betting/competitions-data/',
        title: 'LEAGUES_QUOTAS',
      },
    ],
  },
  {
    path: '/dev-tools',
    title: 'Dev Tools',
    icon: <ExceptionOutlined />,
    claim: userClaims.devToolsPrefix,
    children: [
      {
        path: '/dev-tools/uis',
        title: 'UIS',
        claim: userClaims.uisPrefix,
      },
      {
        path: '/dev-tools/monitor',
        title: 'TICKET_MONITOR',
        claim: userClaims.devToolsTicketMonitor,
      },
      {
        path: '/dev-tools/access-logs',
        title: 'Access Logs',
        claim: userClaims.devToolsAccessLog,
      },
      {
        path: '/dev-tools/nodes',
        title: 'NODES_TITLE',
        claim: userClaims.devToolsNodes,
      },
      {
        path: '/dev-tools/clients',
        title: 'CLIENTS',
        claim: userClaims.devToolsClients,
      },
      {
        path: '/dev-tools/translations',
        title: 'TRANSLATIONS',
        claim: userClaims.devToolsI18N,
      },
      {
        path: '/dev-tools/system-settings',
        title: 'SYSTEM_SETTINGS',
        claim: userClaims.devToolsSystem,
      },
      {
        path: '/dev-tools/system-maintenance',
        title: 'SYSTEM_MAINTENANCE',
        claim: userClaims.maintenance,
      },
    ],
  },
  // {
  //   path: '/business',
  //   title: 'BUSINESS',
  //   icon: <WalletOutlined />,
  //   claim: userClaims.businessPrefix,
  //   children: [
  //     {
  //       path: '/business/balance-atms',
  //       title: 'ATM_BALANCE',
  //       claim: userClaims.businessAtmBalance,
  //     },
  //     // {
  //     //   path: '/business/casino/',
  //     //   title: 'CASINO',
  //     //   children: [
  //     //     {
  //     //       path: '/business/casino/client-status',
  //     //       title: 'CLIENT_STATUS',
  //     //       claim: userClaims.businessCasinoClientSummary
  //     //     },
  //     //     {
  //     //       path: '/business/casino/user-status',
  //     //       title: 'USER_STATUS',
  //     //       claim: userClaims.businessCasinoUsersSummary
  //     //     },
  //     //     {
  //     //       path: '/business/casino/user-transactions',
  //     //       title: 'USER_TRANSACTIONS',
  //     //       claim: userClaims.businessCasinoUsersTransactions
  //     //     }
  //     //   ]
  //     // }
  //   ],
  // },
  {
    path: '/agent-system',
    title: 'AGENT_SYSTEM',
    claim: userClaims.agentSystem,
    icon: <ApartmentOutlined />,
    children: [
      {
        path: '/agent-system/users',
        title: 'Users',
        claim: userClaims.agentSystemUsersRead,
      },
      {
        path: '/agent-system/web-transfer',
        title: 'Money Transfer',
        claim: userClaims.agentSystemMoneyTransfer,
      },
      // {
      //   path: '/agent-system/balance',
      //   title: 'Balance',
      //   claim: userClaims.agentSystemBalance,
      // },
      {
        path: '/agent-system/casino-report',
        title: 'Casino balance',
        claim: userClaims.agentSystemBalance,
      },
      // {
      //   path: '/agent-system/tickets',
      //   title: 'Ticket List',
      //   claim: userClaims.agentSystemTicketsRead,
      // },
    ],
  },
  // {
  //   path: '/administration',
  //   title: 'Admin Commands',
  //   icon: <DatabaseOutlined />,
  //   claim: userClaims.dashBoardPrefix,
  //   children: [
  //     {
  //       path: '/administration/parsers',
  //       title: 'Parser',
  //       claim: userClaims.dashBoardPrefix,
  //       children: [
  //         {
  //           path: '/administration/balance/balance',
  //           title: 'Balance',
  //           claim: userClaims.businessWebTransactionsSummary,
  //         },
  //         // {
  //         //   path: '/administration/balance/casino-report',
  //         //   title: 'Casino balance',
  //         //   claim: userClaims.businessCasinoUsersSummary
  //         // }
  //       ],
  //     },
  //     // {
  //     //   path: '/administration/balance',
  //     //   title: 'WEB_USERS_BALANCE'
  //     // },
  //     // {
  //     //   path: '/administration/casino-report',
  //     //   title: 'Casino balance'
  //     // },
  //     // {
  //     //   path: '/administration/tickets',
  //     //   title: 'Ticket List',
  //     //   claim: userClaims.dashBoardPrefix
  //     // }
  //   ],
  // },
  {
    path: '/users',
    title: 'Users',
    claim: userClaims.usersRead,
    icon: <UserOutlined />,
  },
  {
    path: '/business/atms-and-shops',
    title: 'Aparati i uplatna mesta',
    claim: userClaims.businessPrefix,
    icon: <WalletOutlined />,
  },
  {
    path: '/technical-support',
    title: 'TECHNICAL_SUPPORT',
    claim: userClaims.businessPrefix,
    icon: <UserOutlined />,
  },
  {
    path: '/processing',
    title: 'Processing',
    claim: userClaims.businessPrefix,
    icon: <ClusterOutlined />,
  },

  // {
  //   path: '/accesslogs',
  //   title: 'Access Logs',
  //   icon: <ExceptionOutlined />
  // }
];





